import { render, staticRenderFns } from "./CatalogProductModal.vue?vue&type=template&id=70bd28e8&scoped=true&"
import script from "./CatalogProductModal.vue?vue&type=script&lang=js&"
export * from "./CatalogProductModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductModal.vue?vue&type=style&index=0&id=70bd28e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd28e8",
  null
  
)

export default component.exports